import React, { useEffect, useState } from "react";
import "./Tutorial.css";
import UserProfileBox from "../userProfileBox/UserProfileBox"; // Adjust the import path
import API_URL from "../../apiConfig";
import TopBar from "../../components/TopBar/TopBar";
const videos = [
  {
    title: "Add Brand and Category communication guideline",
    duration: "35 sec",
    url: "https://vimeo.com/1094718420/32ed3912b7",
  },
  {
    title: "Provide Product details",
    duration: "44 sec",
    url: "https://vimeo.com/1094718499/c48b73e3ee",
  },
  {
    title: "Control the task queue",
    duration: "18 sec",
    url: "https://vimeo.com/1094718579/3918726c97",
  },
  {
    title: "Access and download task history",
    duration: "34 sec",
    url: "https://vimeo.com/1094718638/e9bb3a6327",
  },
];

const getVimeoEmbedUrl = (url: string) => {
  const match = url.match(/vimeo\.com\/(\d+)\/([a-zA-Z0-9]+)/);
  return match
    ? `https://player.vimeo.com/video/${match[1]}?h=${match[2]}`
    : "";
};
const toHighResThumbnail = (url: string) => {
  return url.replace(/_\d+x\d+\.jpg$/, "_1280.jpg");
};

const Tutorial: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [playingIndex, setPlayingIndex] = useState<number | null>(null);
  const [thumbnails, setThumbnails] = useState<string[]>([]);
  const [activeVideo, setActiveVideo] = useState<{
    title: string;
    embedUrl: string;
  } | null>(null);

  useEffect(() => {
    const fetchThumbnails = async () => {
      const results = await Promise.all(
        videos.map(async (video) => {
          const response = await fetch(
            `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(
              video.url
            )}`
          );
          const data = await response.json();
          return toHighResThumbnail(data.thumbnail_url);
        })
      );
      setThumbnails(results);
    };

    fetchThumbnails();
  }, []);
  return (
    <div className="tutorial-container">
 <TopBar />
      <div className="tutorial-header">
        <h2 className="tutorial-title">Tutorials</h2>
      </div>

      <div className="video-grid">
        {videos.map((video, index) => (
          <div className="video-preview">
            <div style={{ position: "relative" }}>
              <img
                src={thumbnails[index]}
                alt={video.title}
                style={{
                  width: "100%",
                  height: "180px",
                  objectFit: "cover",
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                }}
              />
              <button
                onClick={() =>
                  setActiveVideo({
                    title: video.title,
                    embedUrl: getVimeoEmbedUrl(video.url),
                  })
                }
                style={{
                  position: "absolute",
                  bottom: "12px",
                  right: "12px",
                  backgroundColor: "#3f5efb",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  color: "#fff",
                  fontSize: "18px",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                }}
              >
                ▶
              </button>
            </div>

            <div style={{ padding: "12px" }}>
              <h4
                style={{
                  margin: "0 0 4px 0",
                  fontSize: "15px",
                  fontWeight: 600,
                }}
              >
                {video.title}
              </h4>
              <p style={{ margin: 0, fontSize: "13px", color: "#888" }}>
                {video.duration}
              </p>
            </div>
          </div>
        ))}

        {/* Modal */}
        {activeVideo && (
          <div
            onClick={() => setActiveVideo(null)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 9999,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                background: "#000",
                borderRadius: "12px",
                padding: "16px",
                width: "90%",
                maxWidth: "720px",
                position: "relative",
              }}
            >
              <button
                onClick={() => setActiveVideo(null)}
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "12px",
                  fontSize: "24px",
                  background: "transparent",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
              <iframe
                src={activeVideo.embedUrl}
                width="100%"
                height="400"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
                title={activeVideo.title}
                style={{ borderRadius: "8px" }}
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tutorial;
